import { createReducer, createActions } from 'reduxsauce';

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  setModalData: ['contactId', 'locationId', 'reason'],
  toggleRequestModal: ['isVisible'],
  showPaymentStep: null,
  addPayedWorker: ['customerId', 'workerId'],
});

export const PaymentTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

// The customer first sees an explanation of why access is needed, and only moves
// on to the payment modal once they choose to continue.
export const MODAL_STAGES = {
  explanation: 'explanation',
  payment: 'payment',
};

export const INITIAL_STATE = {
  isRequestModalVisible: false,
  requestedContactId: null,
  locationId: null,
  reason: null,
  modalStage: MODAL_STAGES.explanation,
  payedWorkers: [],
};

/* ------------- Reducers ------------- */

export const _setModalData = (state, { contactId, locationId, reason = null }) => {
  return {
    ...state,
    requestedContactId: contactId,
    locationId,
    reason,
    modalStage: MODAL_STAGES.explanation,
  };
};

export const _toggleRequestModal = (state, { isVisible }) => {
  return {
    ...state,
    isRequestModalVisible: isVisible,
    modalStage: MODAL_STAGES.explanation,
  };
};

export const _showPaymentStep = (state) => {
  return {
    ...state,
    modalStage: MODAL_STAGES.payment,
  };
};

export const _addPayedWorker = (state, { customerId, workerId }) => {
  return {
    ...state,
    payedWorkers: [...state.payedWorkers, { customerId, workerId }],
  };
};

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_MODAL_DATA]: _setModalData,
  [Types.TOGGLE_REQUEST_MODAL]: _toggleRequestModal,
  [Types.SHOW_PAYMENT_STEP]: _showPaymentStep,
  [Types.ADD_PAYED_WORKER]: _addPayedWorker,
});
